import { emptySplitApi as api } from "../../../emptyApi";
const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    apiPortalV1AssessmentsDebriefSchedulesList: build.query<
      ApiPortalV1AssessmentsDebriefSchedulesListApiResponse,
      ApiPortalV1AssessmentsDebriefSchedulesListApiArg
    >({
      query: (queryArg) => ({
        url: `/api/portal/v1/assessments/debrief-schedules/`,
        params: {
          assessment_period_id: queryArg.assessmentPeriodId,
        },
      }),
    }),
    apiPortalV1AssessmentsDebriefSchedulesCreate: build.mutation<
      ApiPortalV1AssessmentsDebriefSchedulesCreateApiResponse,
      ApiPortalV1AssessmentsDebriefSchedulesCreateApiArg
    >({
      query: (queryArg) => ({
        url: `/api/portal/v1/assessments/debrief-schedules/`,
        method: "POST",
        body: queryArg.debriefScheduleWrite,
      }),
    }),
    apiPortalV1AssessmentsDebriefSchedulesRetrieve: build.query<
      ApiPortalV1AssessmentsDebriefSchedulesRetrieveApiResponse,
      ApiPortalV1AssessmentsDebriefSchedulesRetrieveApiArg
    >({
      query: (queryArg) => ({
        url: `/api/portal/v1/assessments/debrief-schedules/${queryArg.id}/`,
      }),
    }),
    apiPortalV1AssessmentsDebriefSchedulesUpdate: build.mutation<
      ApiPortalV1AssessmentsDebriefSchedulesUpdateApiResponse,
      ApiPortalV1AssessmentsDebriefSchedulesUpdateApiArg
    >({
      query: (queryArg) => ({
        url: `/api/portal/v1/assessments/debrief-schedules/${queryArg.id}/`,
        method: "PUT",
        body: queryArg.debriefScheduleWrite,
      }),
    }),
    apiPortalV1AssessmentsDebriefSchedulesPartialUpdate: build.mutation<
      ApiPortalV1AssessmentsDebriefSchedulesPartialUpdateApiResponse,
      ApiPortalV1AssessmentsDebriefSchedulesPartialUpdateApiArg
    >({
      query: (queryArg) => ({
        url: `/api/portal/v1/assessments/debrief-schedules/${queryArg.id}/`,
        method: "PATCH",
        body: queryArg.patchedDebriefScheduleWrite,
      }),
    }),
    apiPortalV1AssessmentsDebriefSchedulesDestroy: build.mutation<
      ApiPortalV1AssessmentsDebriefSchedulesDestroyApiResponse,
      ApiPortalV1AssessmentsDebriefSchedulesDestroyApiArg
    >({
      query: (queryArg) => ({
        url: `/api/portal/v1/assessments/debrief-schedules/${queryArg.id}/`,
        method: "DELETE",
      }),
    }),
    apiPortalV1AssessmentsDebriefSchedulesSendRemindersCreate: build.mutation<
      ApiPortalV1AssessmentsDebriefSchedulesSendRemindersCreateApiResponse,
      ApiPortalV1AssessmentsDebriefSchedulesSendRemindersCreateApiArg
    >({
      query: (queryArg) => ({
        url: `/api/portal/v1/assessments/debrief-schedules/${queryArg.id}/send_reminders/`,
        method: "POST",
        body: queryArg.debriefSchedule,
      }),
    }),
    apiPortalV1AssessmentsDebriefSchedulesSendRemindersToEmployeesCreate:
      build.mutation<
        ApiPortalV1AssessmentsDebriefSchedulesSendRemindersToEmployeesCreateApiResponse,
        ApiPortalV1AssessmentsDebriefSchedulesSendRemindersToEmployeesCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/portal/v1/assessments/debrief-schedules/send-reminders-to-employees/`,
          method: "POST",
          body: queryArg.body,
        }),
      }),
  }),
  overrideExisting: false,
});
export { injectedRtkApi as portalApi };
export type ApiPortalV1AssessmentsDebriefSchedulesListApiResponse =
  /** status 200  */ DebriefSchedule[];
export type ApiPortalV1AssessmentsDebriefSchedulesListApiArg = {
  assessmentPeriodId: number;
};
export type ApiPortalV1AssessmentsDebriefSchedulesCreateApiResponse =
  /** status 201  */ DebriefScheduleWriteRead;
export type ApiPortalV1AssessmentsDebriefSchedulesCreateApiArg = {
  debriefScheduleWrite: DebriefScheduleWrite;
};
export type ApiPortalV1AssessmentsDebriefSchedulesRetrieveApiResponse =
  /** status 200  */ DebriefSchedule;
export type ApiPortalV1AssessmentsDebriefSchedulesRetrieveApiArg = {
  /** A unique integer value identifying this debrief schedule. */
  id: number;
};
export type ApiPortalV1AssessmentsDebriefSchedulesUpdateApiResponse =
  /** status 200  */ DebriefScheduleWriteRead;
export type ApiPortalV1AssessmentsDebriefSchedulesUpdateApiArg = {
  /** A unique integer value identifying this debrief schedule. */
  id: number;
  debriefScheduleWrite: DebriefScheduleWrite;
};
export type ApiPortalV1AssessmentsDebriefSchedulesPartialUpdateApiResponse =
  /** status 200  */ DebriefScheduleWriteRead;
export type ApiPortalV1AssessmentsDebriefSchedulesPartialUpdateApiArg = {
  /** A unique integer value identifying this debrief schedule. */
  id: number;
  patchedDebriefScheduleWrite: PatchedDebriefScheduleWrite;
};
export type ApiPortalV1AssessmentsDebriefSchedulesDestroyApiResponse = unknown;
export type ApiPortalV1AssessmentsDebriefSchedulesDestroyApiArg = {
  /** A unique integer value identifying this debrief schedule. */
  id: number;
};
export type ApiPortalV1AssessmentsDebriefSchedulesSendRemindersCreateApiResponse =
  /** status 200  */ any;
export type ApiPortalV1AssessmentsDebriefSchedulesSendRemindersCreateApiArg = {
  /** A unique integer value identifying this debrief schedule. */
  id: number;
  debriefSchedule: DebriefSchedule;
};
export type ApiPortalV1AssessmentsDebriefSchedulesSendRemindersToEmployeesCreateApiResponse =
  /** status 200  */ any;
export type ApiPortalV1AssessmentsDebriefSchedulesSendRemindersToEmployeesCreateApiArg =
  {
    body: {
      /** List of Employee IDs to send reminders to */
      employee_ids: number[];
      /** ID of the DebriefSchedule */
      debrief_schedule_id: number;
    };
  };
export type Participant = {
  id: number;
  name: string;
  email: string;
  status: number;
  reminderCount: number;
  lastEmailSentAt?: string | null;
  lastEmailSuccessful?: boolean | null;
  lastEmailStatus?: string | null;
  lastEmailError?: string | null;
  emailHistory?: any | null;
  briefToken?: string | null;
  briefTokenId?: number | null;
};
export type DebriefSchedule = {
  id: number;
  name: string;
  title: string;
  status: number;
  scheduled_for?: string | null;
  close_at?: string | null;
  participants: Participant[];
  invitationCount: number;
  responseCount: number;
  completionRate: number;
  leader?: number | null;
  nameUid?: string | null;
  total_requests?: number;
  total_responses?: number;
  assessment_period_status?: number | null;
  team_id?: number | null;
};
export type DebriefScheduleWriteStatusEnum = 1 | 3 | 5 | 9 | 21;
export type DebriefScheduleWriteTypeOfEnum = 1 | 2 | 3 | 4 | 5;
export type DebriefScheduleWrite = {
  name?: string | null;
  secondary?: string[] | null;
  name_uid?: string | null;
  organization?: number | null;
  brief_question?: number | null;
  survey_structure?: number | null;
  time_zone?: string | null;
  scheduled_for?: string | null;
  include_leaders?: boolean;
  include_members?: boolean;
  close_at?: string | null;
  close_in_minutes?: number | null;
  status?: DebriefScheduleWriteStatusEnum;
  type_of?: DebriefScheduleWriteTypeOfEnum;
  compliance?: any | null;
  request_list?: any | null;
  summary?: any | null;
  additional_type?: any | null;
  assessment_period?: number | null;
  leader?: number | null;
};
export type DebriefScheduleWriteRead = {
  id: number;
  name?: string | null;
  secondary?: string[] | null;
  name_uid?: string | null;
  organization?: number | null;
  brief_question?: number | null;
  survey_structure?: number | null;
  time_zone?: string | null;
  scheduled_for?: string | null;
  include_leaders?: boolean;
  include_members?: boolean;
  close_at?: string | null;
  close_in_minutes?: number | null;
  status?: DebriefScheduleWriteStatusEnum;
  type_of?: DebriefScheduleWriteTypeOfEnum;
  compliance?: any | null;
  request_list?: any | null;
  summary?: any | null;
  additional_type?: any | null;
  assessment_period?: number | null;
  leader?: number | null;
};
export type PatchedDebriefScheduleWrite = {
  name?: string | null;
  secondary?: string[] | null;
  name_uid?: string | null;
  organization?: number | null;
  brief_question?: number | null;
  survey_structure?: number | null;
  time_zone?: string | null;
  scheduled_for?: string | null;
  include_leaders?: boolean;
  include_members?: boolean;
  close_at?: string | null;
  close_in_minutes?: number | null;
  status?: DebriefScheduleWriteStatusEnum;
  type_of?: DebriefScheduleWriteTypeOfEnum;
  compliance?: any | null;
  request_list?: any | null;
  summary?: any | null;
  additional_type?: any | null;
  assessment_period?: number | null;
  leader?: number | null;
};
export type PatchedDebriefScheduleWriteRead = {
  id?: number;
  name?: string | null;
  secondary?: string[] | null;
  name_uid?: string | null;
  organization?: number | null;
  brief_question?: number | null;
  survey_structure?: number | null;
  time_zone?: string | null;
  scheduled_for?: string | null;
  include_leaders?: boolean;
  include_members?: boolean;
  close_at?: string | null;
  close_in_minutes?: number | null;
  status?: DebriefScheduleWriteStatusEnum;
  type_of?: DebriefScheduleWriteTypeOfEnum;
  compliance?: any | null;
  request_list?: any | null;
  summary?: any | null;
  additional_type?: any | null;
  assessment_period?: number | null;
  leader?: number | null;
};
export const {
  useApiPortalV1AssessmentsDebriefSchedulesListQuery,
  useApiPortalV1AssessmentsDebriefSchedulesCreateMutation,
  useApiPortalV1AssessmentsDebriefSchedulesRetrieveQuery,
  useApiPortalV1AssessmentsDebriefSchedulesUpdateMutation,
  useApiPortalV1AssessmentsDebriefSchedulesPartialUpdateMutation,
  useApiPortalV1AssessmentsDebriefSchedulesDestroyMutation,
  useApiPortalV1AssessmentsDebriefSchedulesSendRemindersCreateMutation,
  useApiPortalV1AssessmentsDebriefSchedulesSendRemindersToEmployeesCreateMutation,
} = injectedRtkApi;
